import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	congrats: {
		id: 'partner.success.congrats',
		defaultMessage: 'Congratulations!',
		description: 'Success congrats',
	},
	successText: {
		id: 'partner.success.downloadApp',
		defaultMessage:
			"You have access to <bold>Calm Premium!</bold>{breakingLine}We recommend downloading the Calm app and starting your journey there.{breakingLine}After downloading the app, {login} to unlock the premium content.{breakingLine}You'll find a comprehensive library of content from Meditations, Sleep Stories, and Music. All to help you manage stress, mental health, and so much more.{breakingLine}",
		description: 'Success body text',
	},
	successTextFacebook: {
		id: 'partner.success.useFbLogin',
		defaultMessage: 'choose Log in with Facebook',
		description: 'Indicates the user should login with Facebook',
	},
	successTextEmail: {
		id: 'partner.success.useEmailLogin',
		defaultMessage: 'log in with your email address {customerEmail}',
		description: 'Indicates the user should login with their provided email',
	},
});
